import React, { useEffect } from "react";
import {
  Route,
  Switch,
  useRouteMatch,
  useLocation,
  Redirect,
} from "react-router-dom";
import { RequestCache } from "shared/@hooks/useRequestCache";
import { Auth } from "shared/@auth/Auth";
import Page, { Content, Nav, NavGroup, NavItem } from "shared/Page";
import { CMSData } from "./CMS/useCMSData";
import CategoryBuilder from "./CategoryBuilder";
import CMS from "./CMS";
import SSFSort from "./SSFSort";
// import NewsAdmin from "./NewsAdmin";
import { useCurrentRoute } from "../shared/@hooks/useCurrentRoute.js";
import { ReactComponent as Info_Center_Icon } from "./CMS/icons/Info_Center_Icon.svg";
import { ReactComponent as Category_Builder_Icon } from "./CMS/icons/Category_Builder_Icon.svg";
import { ReactComponent as SSF_Sort_Icon } from "./CMS/icons/SSF_Sort_Icon.svg";
import { ReactComponent as News_Icon } from "./CMS/icons/Home_Feed_Admin_Icon (1).svg";

export function Marketing() {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();
  const { setCurrentRoute } = useCurrentRoute();
  const location = useLocation();

  useEffect(() => {
    setCurrentRoute("/marketing");
    return () => {
      setCurrentRoute("");
    };
  });

  // icon colors
  const styles = (pathname) => {
    return {
      filter: !location.pathname.includes(pathname)
        ? "var(--icon-filter)"
        : "var(--icon-filter-invert",
    };
  };

  return (
    <RequestCache.Provider>
      <Page>
        <Nav>
          <NavGroup title="Marketing">
            {hasPermission("marketing.cms.read") && (
              <NavItem
                to={`${path}/cms`}
                icon={<Info_Center_Icon style={styles("cms")} />}
              >
                CMS
              </NavItem>
            )}
            {hasPermission("marketing.categorybuilder.read") && (
              <NavItem
                to={`${path}/category-builder`}
                icon={
                  <Category_Builder_Icon style={styles("category-builder")} />
                }
              >
                Category Builder
              </NavItem>
            )}
            {hasPermission("marketing.categorybuilder.read") && (
              <NavItem
                to={`${path}/ssf-sort`}
                icon={<SSF_Sort_Icon style={styles("ssf-sort")} />}
              >
                SSF Sort
              </NavItem>
            )}
            {(hasPermission("developer.*") ||
              hasPermission("marketing.news.read")) && (
              <NavItem to={"https://dev-news.wwg.support"} icon={<News_Icon />}>
                News
              </NavItem>
            )}
          </NavGroup>
        </Nav>
        <Content>
          <Switch>
            <Route exact path={path}>
              {hasPermission("marketing.cms.read") ? (
                <Redirect to={`${path}/cms`} />
              ) : (
                <div style={{ padding: "1rem" }}>
                  You don’t have access to this section.
                </div>
              )}
            </Route>

            {hasPermission("marketing.categorybuilder.read") && (
              <Route path={`${path}/category-builder`}>
                <CategoryBuilder />
              </Route>
            )}

            {hasPermission("marketing.categorybuilder.read") && (
              <Route path={`${path}/ssf-sort`}>
                <SSFSort />
              </Route>
            )}
            {hasPermission("marketing.cms.read") && (
              <CMSData.Provider>
                <Route path={`${path}/cms`}>
                  <CMS />
                </Route>
              </CMSData.Provider>
            )}
          </Switch>
        </Content>
      </Page>
    </RequestCache.Provider>
  );
}
